<template>
  <div class="">
    <div class="mine-box-title">认证结果</div>
    <div class="mine-content">
      <div class="order-success" v-if="row.registstatus==2">
        <div class="icon"></div>
        <div class="title">备案成功</div>
        <p>请继续相关操作</p>
      </div>
      <div class="order-success" v-else-if="row.registstatus==1">
        <div class="icon icon-wait"></div>
        <div class="title">等待审核中</div>
        <p>请等待管理员审核</p>
      </div>
      <div class="order-success" v-else-if="row.registstatus==3">
        <div class="icon icon-closed"></div>
        <div class="title">审核未通过</div>
        <p>拒绝理由:{{ row.registstatusdes }}</p>
      </div>
      <div class="order-success" v-else>
        <div class="icon icon-wait"></div>
        <div class="title">未提交</div>
        <p>请先提交备案</p>
      </div>


      <van-cell-group>
        <van-cell
            input-align="right"
            title="单位"
            :value="row.name"
        />
      </van-cell-group>

      <div class="" v-if="row.registstatus != 1" style="text-align:center">
        <van-button
            v-rblink="{name:'SaiDateList','query':{ }}"
            v-if="row.registstatus==2"
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem ; margin:0 auto;"
            size="normal" round>继续报名
        </van-button>
        <van-button
            v-rblink="{name:'CertDanwei','query':{ }}"
            v-else-if="row.registstatus==3"
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem; margin:0 auto;"
            size="normal" round>重新备案
        </van-button>
        <van-button
            v-rblink="{name:'CertDanwei','query':{ }}"
            v-else-if="row.registstatus==0"
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem; margin:0 auto;"
            size="normal" round>单位备案
        </van-button>
      </div>
    </div>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.icon-closed {
  background-image: url(../../../assets/images/icon-order-close.png) !important;
}

.icon-wait {
  background-image: url(../../../assets/images/icon-order-delivery.png) !important;
}

.order-success {
  text-align: center;
  margin: 20px 0;
}

.order-success .icon {
  background: url(../../../assets/images/icon-order-done.png);
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.order-success img {
  width: 120px;
  height: 120px;
  margin: 10px auto;
}

.order-success p {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li {
  background: #f3f3f3;
  border-radius: 10px;
  margin: 20px 10px;
  padding: 10px;
}

.sai-shuo-li img {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  float: left;
  margin-right: 10px;
}

.sai-shuo-li .c {
  width: calc(100% - 80px);
  border-right: 1px solid #00000008;
}

.sai-shuo-li .c .title {
  font-size: 14px;
  color: #000;
}

.sai-shuo-li .c .desc {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li .fr {
  width: 70px;
  float: right;
}

.sai-shuo-li .btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 6px;
  color: #fff;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CertDanweiResult',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      row: {}
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "认证结果"
    this.fetch();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post('/api/danwei/detail', {}, (res) => {
        that.row = res.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// CertDanweiResult.vue?6a05dcde